const orgaos = [
  '',
  ',ABNC ',
  'AGU ',
  'ANAC ',
  'CAER ',
  'CAU ',
  'CBM ',
  'CFA ',
  'CFB ',
  'CFBIO ',
  'CFBM ',
  'CFC ',
  'CFESS ',
  'CFF ',
  'CFFA ',
  'CFM ',
  'CFMV ',
  'CFN ',
  'CFO ',
  'CFP ',
  'CFQ ',
  'CFT ',
  'CFTA ',
  'CGPI ',
  'CGPMAF ',
  'CIPC ',
  'CNIG ',
  'CNT ',
  'CNTV ',
  'COFECI ',
  'COFECON ',
  'COFEM ',
  'COFEN ',
  'COFFITO ',
  'COMAER ',
  'CONFE ',
  'CONFEA ',
  'CONFEF ',
  'CONFERE ',
  'CONRE ',
  'CONRERP ',
  'CORE ',
  'CORECON ',
  'COREM ',
  'COREN ',
  'CRA ',
  'CRAS ',
  'CRB ',
  'CRBIO ',
  'CRBM ',
  'CRC ',
  'CREA ',
  'CRECI ',
  'CREF ',
  'CREFITO ',
  'CRESS ',
  'CRF ',
  'CRFA ',
  'CRM ',
  'CRMV ',
  'CRN ',
  'CRO ',
  'CRP ',
  'CRPRE ',
  'CRQ ',
  'CRT ',
  'CRTA ',
  'CTPS ',
  'CV ',
  'DELEMIG ',
  'DETRAN ',
  'DGPC ',
  'DIC ',
  'DICC ',
  'DIREX ',
  'DPF ',
  'DPMAF ',
  'DPT ',
  'DPTC ',
  'DREX ',
  'DRT ',
  'EB ',
  'FAB ',
  'FENAJ ',
  'FGTS ',
  'FIPE ',
  'FLS ',
  'FUNAI ',
  'GEJSP ',
  'GEJSPC ',
  'GEJUSPC ',
  'GESP ',
  'GOVGO ',
  'I CLA ',
  'ICP ',
  'IDAMP ',
  'IFP ',
  'IGP ',
  'IIACM ',
  'IICC ',
  'IICCECF ',
  'IICM ',
  'IIGP ',
  'IIJDM ',
  'IIPC ',
  'IIPC ',
  'IIRGD ',
  'IIRHM ',
  'IITB ',
  'IML ',
  'INI ',
  'IPF ',
  'ITCP ',
  'ITEP ',
  'MAER ',
  'MB ',
  'MD ',
  'MDS ',
  'MEC ',
  'MEX ',
  'MINDEF ',
  'MJ ',
  'MM ',
  'MMA ',
  'MPAS ',
  'MPE ',
  'MPF ',
  'MPT ',
  'MRE ',
  'MT ',
  'MTE ',
  'MTPS ',
  'NUMIG ',
  'OAB ',
  'OMB ',
  'PC ',
  'PF ',
  'PGFN ',
  'PM ',
  'POLITEC ',
  'PRF ',
  'PTC ',
  'SCC ',
  'SCJDS ',
  'SDS ',
  'SECC ',
  'SECCDE ',
  'SEDS ',
  'SEGUP ',
  'SEJSP ',
  'SEJUC ',
  'SEJUSP ',
  'SEPC ',
  'SES ',
  'SESC ',
  'SESDC ',
  'SESDEC ',
  'SESEG ',
  'SESP ',
  'SESPAP ',
  'SESPDC ',
  'SESPDS ',
  'SGPC ',
  'SGPJ ',
  'SIM ',
  'SJ ',
  'SJCDH ',
  'SJDS ',
  'SJS ',
  'SJTC ',
  'SJTS ',
  'SNJ ',
  'SPMAF ',
  'SPTC ',
  'SRDPF ',
  'SRF ',
  'SRTE ',
  'SSDC ',
  'SSDS ',
  'SSI ',
  'SSP ',
  'SSPCGP ',
  'SSPDC ',
  'SSPDS ',
  'SSPPC ',
  'SUSEP ',
  'SUSEPE ',
  'TJ ',
  'TJAEM ',
  'TRE ',
  'TRF ',
  'TSE ',
  'XXX ',
  'ZZZ ',
];
const siglasEstados = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
];

export { orgaos, siglasEstados };
